"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ImageForm_1 = __importDefault(require("./Form/ImageForm"));
const react_1 = __importDefault(require("react"));
const react_2 = require("@remirror/react");
const ImageRounded_1 = __importDefault(require("@mui/icons-material/ImageRounded"));
const FormModal_1 = __importDefault(require("../../../ui/Modal/FormModal"));
const Extensions_1 = require("../../../Extensions/Extensions");
const ImageModal = ({ onCancel, onSubmit }) => {
    const selection = (0, react_2.useCurrentSelection)();
    const currentImage = selection?.node;
    const currentImageAttrs = { ...currentImage?.attrs };
    const formData = {
        imageType: currentImage?.type.name === Extensions_1.NodeName.Image ? Extensions_1.NodeName.Image : Extensions_1.NodeName.AssetImage,
        image: currentImage?.type?.name === Extensions_1.NodeName.Image ? currentImageAttrs : {},
        resourceImage: currentImage?.type?.name === Extensions_1.NodeName.DAMImage || currentImage?.type?.name === Extensions_1.NodeName.AssetImage
            ? currentImageAttrs
            : {},
    };
    return (react_1.default.createElement(FormModal_1.default, { title: "Image", icon: react_1.default.createElement(ImageRounded_1.default, null), onCancel: onCancel },
        react_1.default.createElement(ImageForm_1.default, { data: formData, onSubmit: onSubmit })));
};
exports.default = ImageModal;
